// The words for what the server answers to the commercial team of the central base (pure, tested).
import { DUPLICATE_REASONS } from './commercialDuplicates.js';

const OWNER = { other: 'ya lo trabaja otra persona del equipo', none: 'todavía no tiene responsable', unclear: 'tiene una asignación por resolver' };

/** One match as the collaborator may read it (never data outside their reach: the server already left it out). */
export function matchText(m) {
  const why = DUPLICATE_REASONS[m.reason] || 'datos que coinciden';
  if (m.inBatch) return `Otra fila de esta misma carga tiene ${why}.`;
  if (m.level === 'warn') return m.yours ? `«${m.name}» tiene ${why}.` : `Un registro con ${why} que ${OWNER[m.owner] || OWNER.unclear}.`;
  if (m.yours) return `Ya existe «${m.name}» con ${why}: usá ese registro.`;
  return `Ya existe un registro con ${why} que ${OWNER[m.owner] || OWNER.unclear}. No lo crees: pedile a Ale que te lo asigne.`;
}

export const TEAM_ERRORS = {
  duplicate: 'No se creó: ya existe un registro con los mismos datos.',
  assignment_history_missing: 'Para asignar empresas falta el campo «Assignment History» en Accounts (pedido para Omni en docs/fiabilidad.md). No se cambió nada.',
  assignment_path: 'El responsable de una empresa se cambia solo desde «Responsable» (queda en su historial).',
  assignment_changed: 'Alguien cambió el responsable mientras tanto. Volvé a cargar y revisalo antes de cambiarlo.',
  team_user_missing: 'Tu usuario todavía no está vinculado en Oike (falta una ficha en Users con tu email). Pedíselo a Ale.',
  team_user_ambiguous: 'Hay más de una ficha en Users con tu email. Pedile a Ale que lo resuelva.',
  user_without_email: 'Esa persona no tiene un email único en su ficha de Users: no puede recibir empresas.',
  user_email_ambiguous: 'Ese email está en más de una ficha de Users: resolvelo antes de asignar.',
  'Only the administration assigns accounts': 'Solo Ale asigna empresas.',
  'Only the administration deletes records': 'Solo Ale puede borrar registros.',
  'Table not available for this profile': 'Esta parte no está disponible para tu perfil.',
  'A linked record is out of reach': 'Ese registro está vinculado a una empresa que no tenés asignada.',
  'Not found': 'No se encontró (o ya no está asignado a vos).',
  'Could not check access; try again': 'No se pudo comprobar el acceso. Volvé a intentarlo.',
};

/** The message of an error answer of the proxy or team.mts, or '' when it is not one of these. */
export function teamErrorText(data) {
  const code = data?.error;
  if (!code || !TEAM_ERRORS[code]) return '';
  if (code === 'duplicate') {
    const ms = data.matches || (data.records || []).flatMap(r => r.matches || []);
    const first = ms.find(Boolean);
    return first ? `${TEAM_ERRORS.duplicate} ${matchText(first)}` : TEAM_ERRORS.duplicate;
  }
  return TEAM_ERRORS[code];
}
